// extracted by mini-css-extract-plugin
export default {"image":"background__image__CdDy1","color":"background__color__cckfn","video":"background__video__GdJvs","videoEnabled":"background__videoEnabled__LyHIW"};